<template>
  <section class="customcheckerboard-size-selector">
    <div :class="[
      'customcheckerboard-size-selector-body',
      'customcheckerboard-main-views-wrapper-body'
    ]">
      <h5
        :class="[
          'customcheckerboard-size-selector-title',
          'customcheckerboard-main-views-wrapper-title',
          'text-center',
        ]">{{ translations.customCheckerboardSizeTitle }}</h5>
      <div class="customcheckerboard-size-selector-choose-sizes">
        <div
            class="customcheckerboard-size-selector-item"
            v-for="(item, size) in checkerboardSize"
            :key="item.label"
          >
          <div @click="selectSize(size, item.dataLayerName)" :class="[
            'customcheckerboard-size-selector-image',
            {'customcheckerboard-size-selector-image-active': size === selectedSize}
          ]">
            <div
              v-show="size === selectedSize"
              class="customcheckerboard-size-selector-icon-check icon-check"
            ></div>
            <checkerboard-fabric-canvas
              :tileConfig="item.tileConfig"
              :color1="canvasConfig.color1"
              :color2="canvasConfig.color2"
              :canvasWidth="canvasWidth"
              :canvasHeight="91"
              @canvasLoaded="canvasLoaded"
            ></checkerboard-fabric-canvas>
          </div>
          <span class="customcheckerboard-size-selector-label text-center">{{ translations[item.label] }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import checkerboardFabricCanvas from '../../FabricCanvas/CheckerboardFabricCanvas';

export default {
  name: "checkerboardSizeSelector",
  components: {
    checkerboardFabricCanvas
  },
  data() {
    return {
      selectedSize: null,
      canvasSizeComponents: 0
    };
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    canvasWidth() {
      const width = window.innerWidth - (window.innerWidth * 0.25);
      if (width < 315) return width;
      return 315;
    },
    canvasConfig() {
      return this.$store.state.customCheckerboard.canvasConfig;
    },
    checkerboardSize() {
      return this.$store.state.customCheckerboard.sizeData.checkerboardSize;
    }
  },
  methods: {
    /**
     * @function canvasLoaded
     * Event for the child component(checkerboard-fabric-canvas) to be emitted
     * once the canvas is rendered.
     * Once the all sizes are loaded, update enable controls with true.
     */
    canvasLoaded() {
      this.canvasSizeComponents++;
      if (this.canvasSizeComponents == Object.keys(this.checkerboardSize).length) {
        this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", true);
      }
    },
    selectSize(size, dataLayerName){
      this.selectedSize = size;
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$checkerboardDataLayer.logAnalyticsEvent({action: 'Select Checkerboard Size', eventLabel: dataLayerName });
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('customCheckerboard/SET_CANVAS_CONFIG', { size: this.selectedSize });
    this.$emit('sizeSelected', this.checkerboardSize[this.selectedSize]['canvasConfig']);
  },

  created() {
    this.selectedSize = this.$store.state.customCheckerboard.canvasConfig.size;
    // This is useful to prevent race condition since the canvasLoaded variable in the parent
    // will change after the warpSelector component is loaded and warpGlfx will be rendered twice.
    this.$emit('setCanvasLoaded', false);
  }
};
</script>
